$(document).ready(function () {
    
    const citiesData = {
        bangalore: ["Bangalore"],
        hyderabad: ["Hyderabad"],
        new_delhi: ["New Delhi"],
        delhi: ["Delhi"],
        noida: ["Noida"],
        faridabad: ["Faridabad"],
        gurugram: ["Gurugram"],
        pune: ["Pune"],
        lucknow: ["Lucknow"],
        vizag: ["Vizag"],
        dehradun: ["Dehradun"],
    };

    const storesData = {
        bangalore: [
        "Aukera- Dickenson Road, Bangalore",
        "Aukera- Sarjapur, Bangalore",
        "Aukera- HSR Layout, Bangalore",
        "Aukera- Electronic City, Bangalore",
        "Aukera- Jayanagar, Bangalore",
        "Aukera- Orion Mall, Bangalore",
        "Aukera- Vega City Mall, Bangalore",
        "Aukera- Whitefield, Bangalore"
        ],
        hyderabad: [
        "Aukera-Jubilee Hills, Hyderabad",
        "Aukera-Inorbit Mall, Hyderabad",
        "Aukera-Banjara Hills, Hyderabad",
        "Aukera-Somajiguda, Hyderabad",
        "Aukera-Kondapur, Hyderabad",
        "Aukera-Sarath City Mall, Hyderabad",
        "Aukera-Nexus Mall, Hyderabad"
        ],
        new_delhi: [
        "Aukera- Lajpat Nagar, New Delhi",
        "Aukera- Pacific Mall, Pitampura, New Delhi"
        ],
        delhi: [
        "Aukera- Dwarka, Delhi",
        "Aukera- Rohini, Delhi"
        ],
        noida: [
        "Aukera- Wave One Mall, Noida",
        "Aukera- Aditya Capital Mall, Noida",
        "Aukera- Gaur City Mall, Greater Noida"
        ],
        faridabad: [
        "Aukera - The Mall of Faridabad"
        ],
        gurugram: [
        "Aukera- Good Earth Sixty9 Mall, Gurugram"
        ],
        pune: [
        "Aukera- Paud Road, Pune"
        ],
        lucknow: [
        "Aukera- Lulu Mall, Lucknow"
        ],
        vizag: [
        "Aukera- Inorbit Mall, Vizag"
        ],
        dehradun: [
        "Aukera- Dehradun"
        ],
    };

    if ($('.allCitiesList').length) {

        let $cityDropdown = $('.allCitiesList');
        $cityDropdown.find('option:not(:first)').remove();
        $.each(citiesData, function (key, cities) {
            $.each(cities, function (index, city) {
                $cityDropdown.append(
                    `<option data-handle="${key}" value="${city}">${city}</option>`
                );
            });
        });

    }

    $('.allCitiesList').on('change', function () {

        const selectedHandle = $(this).find(':selected').data('handle');
        const $storeSelect = $('#preferred_store');

        $storeSelect.html('<option selected disabled value="">Select Store</option>');

        if (storesData[selectedHandle]) {
        $.each(storesData[selectedHandle], function (index, store) {
            $storeSelect.append(
            $('<option>', {
                value: store,
                text: store
            })
            );
        });
        }

    });

    function getHubSpotCookie() {
        const match = document.cookie.match(/hubspotutk=([^;]+)/);
        return match ? match[1] : null;
    }

    function getUserIP() {
        return fetch('https://api.ipify.org?format=json')
            .then(response => response.json())
            .then(data => data.ip)
            .catch(error => {
                console.error('Could not fetch IP:', error);
                return null;
            });
    }

    $.validator.addMethod('email_rule', function (value, element) {
        // 1. Trim spaces from start and end
        value = value.trim();

        // 2. Reject spaces anywhere in the email
        if (/\s/.test(value)) {
            return false;
        }

        // 3. Must have exactly one @
        var parts = value.split('@');
        if (parts.length !== 2) {
            return false;
        }

        var localPart = parts[0];
        var domainPart = parts[1];

        // 4. Local part cannot start or end with a dot
        if (/^\./.test(localPart) || /\.$/.test(localPart)) {
            return false;
        }

        // 5. Local part cannot have consecutive dots
        if (/\.\./.test(localPart)) {
            return false;
        }

        // 6. Domain part cannot start or end with a dot
        if (/^\./.test(domainPart) || /\.$/.test(domainPart)) {
            return false;
        }

        // 7. Domain part cannot have consecutive dots
        if (/\.\./.test(domainPart)) {
            return false;
        }

        // 8. Use regex to check overall format
        var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;
        if (!emailRegex.test(value)) {
            return false;
        }

        // Passed all checks
        return true;
    }, 'Please enter a valid email address');

    $(".spaceRemove").on("keypress keyup blur", function (event) {
        $(this).val($(this).val().replace(/\s/g, ""));
        if (event.which === 32) {
            event.preventDefault();
        }
    });

    $.validator.addMethod('name_rule', function (value, element) {
        if (/^[a-zA-Z ]+$/.test(value)) {
            return true;
        } else {
            return false;
        };
    });

    $.validator.addMethod("trimmed", function (value, element) {
        return this.optional(element) || $.trim(value).length > 0;
    }, "This field cannot be empty after trimming.");

    $(document).on("keypress keyup blur", ".phone_number_only", function (event) {
        $(this).val($(this).val().replace(/[^\d].+/, ""));
        if ((event.which < 48 || event.which > 57)) {
            event.preventDefault();
        }
    });

    var paudRoadPune = $('#paudRoadPune').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                required: true,
                email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                required: "Please enter your email",
                email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            element.after(error);
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") }
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/5ed332de-8a64-4029-9051-8d90b24abe2d", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var lucknowLandingPage = $('#lucknowLandingPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                required: true,
                email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                required: "Please enter your email",
                email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            element.after(error);
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) { 
                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") }
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/af387a14-ea06-47b9-8c1d-45715e7bdf84", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {
                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var dehradunLandingPage = $('#dehradunLandingPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                required: true,
                email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                required: "Please enter your email",
                email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            element.after(error);
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") }
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/864c63f7-3d90-4649-9e40-8d647fc82f88", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {
                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var vizagLandingPage = $('#vizagLandingPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                required: true,
                email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                required: "Please enter your email",
                email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            element.after(error);
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {
                
                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") }
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/68a9e54d-b9a8-4aea-93c8-4f11808899dd", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {
                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var foundationDayLandingPage = $('#foundationDayLandingPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            preferred_stores: {
                required: true
            },
            email: {
                required: true,
                email_rule: true
            },
            contact_numbers: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            preferred_date: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            preferred_stores: {
                required: "Please select store",
            },
            email: {
                required: "Please enter your email",
                email_rule: "Please enter a valid email address"
            },
            contact_numbers: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            preferred_date: {
                required: "Please select date",
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            element.after(error);
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                var fullName = formData.get("full_name");
                var preferredStores = formData.get("preferred_stores");
                var emailAdd = formData.get("email");
                var contactNumbers = formData.get("contact_numbers");
                var preferredDate = formData.get("preferred_date");

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "preferred_stores", value: formData.get("preferred_stores") },
                        { name: "email", value: formData.get("email") },
                        { name: "contact_numbers", value: formData.get("contact_numbers") },
                        { name: "preferred_date", value: formData.get("preferred_date") }
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/a250395f-ad7e-456a-9d3d-8f48fec1d729", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {
                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: contactNumbers,
                            store: preferredStores,
                            date: preferredDate
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var ashtalakshmiLandingPage = $('#ashtalakshmiLandingPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                required: true,
                email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                required: "Please enter your email",
                email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            element.after(error);
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: "-" }
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/833cd337-651e-425b-8bf3-c7a0dbfe6e4e", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {
                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: "-"
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var extraBrilliantLandingPage = $('#extraBrilliantLandingPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                required: true,
                email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            city: {
                required: true
            },
            preferred_store: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                required: "Please enter your email",
                email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            city: {
                required: "Please select your city"
            },
            preferred_store: {
                required: "Please select store"
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            element.after(error);
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var storeName = formData.get("preferred_store");

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "preferred_store", value: formData.get("preferred_store") }
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/9f09bb01-ed06-4310-b30b-51487de973ae", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            store: storeName
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });



        },
    });

    var bridalBangaloreForm = $('#bridalBangaloreForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                required: true,
                email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            preferred_store: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                required: "Please enter your email",
                email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            preferred_store: {
                required: "Please select store"
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            element.after(error);
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var storeName = formData.get("preferred_store");

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "preferred_store", value: formData.get("preferred_store") }
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/d05d5e24-88d2-41b6-9d1d-f505f8d26ffe", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            store: storeName
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var bridalHyderabadForm = $('#bridalHyderabadForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                required: true,
                email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            preferred_store: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                required: "Please enter your email",
                email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            preferred_store: {
                required: "Please select store"
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            element.after(error);
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var storeName = formData.get("preferred_store");

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "preferred_store", value: formData.get("preferred_store") }
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/20d889a8-84da-461f-a781-3df2d1de7f8b", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            store: storeName
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var bridalDelhiForm = $('#bridalDelhiForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                required: true,
                email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            preferred_store: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                required: "Please enter your email",
                email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            preferred_store: {
                required: "Please select store"
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            element.after(error);
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var storeName = formData.get("preferred_store");

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "preferred_store", value: formData.get("preferred_store") }
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/2577a45e-f4b2-4bb5-96e3-35872843a416", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            store: storeName
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var orchidForm = $('#orchidForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                required: true,
                email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            city: {
                required: true
            },
            preferred_store: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                required: "Please enter your email",
                email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            city: {
                required: "Please select city"
            },
            preferred_store: {
                required: "Please select store"
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            element.after(error);
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var storeName = formData.get("preferred_store");

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "preferred_store", value: formData.get("preferred_store") }
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/6ce753f3-c424-4220-af43-27d97ff2b0dd", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            store: storeName
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var bridalForm = $('#bridalForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                required: true,
                email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            city: {
                required: true
            },
            preferred_store: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                required: "Please enter your email",
                email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            city: {
                required: "Please select city"
            },
            preferred_store: {
                required: "Please select store"
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            element.after(error);
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var storeName = formData.get("preferred_store");

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "preferred_store", value: formData.get("preferred_store") }
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/cb163526-dc4e-4f2e-9d38-5efc0cc73277", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            store: storeName
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var giftingForm = $('#giftingForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                required: true,
                email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            city: {
                required: true
            },
            preferred_store: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                required: "Please enter your email",
                email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            city: {
                required: "Please select city"
            },
            preferred_store: {
                required: "Please select store"
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            element.after(error);
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var storeName = formData.get("preferred_store");

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "preferred_store", value: formData.get("preferred_store") }
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/f7711b9e-6f16-4fb7-bda4-fbe404dea78e", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            store: storeName
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });


});